export default __webpack_public_path__ + "static/media/comment.0d8544f3.svg";